import apiClient from "./axios"

export const getAccountExpenseTypeList = async (params = {}) => {
  const { data } = await apiClient.get("/account-expense-types", { params })
  return data
}

export const getAccountExpenseTypeById = async id => {
  const { data } = await apiClient.get(`/account-expense-types/${id}`)
  return data
}

export const createAccountExpenseType = async payload => {
  const { data } = await apiClient.post("/account-expense-types", payload)
  return data
}

export const updateAccountExpenseType = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-expense-types/${id}`, payload)
  return data
}

export const deleteAccountExpenseType = async id => {
  const { data } = await apiClient.delete(`/account-expense-types/${id}`)
  return data
}
